// NOTE: This module must NOT import `./index`. `./index` imports these routes,
// so importing it back creates a circular dependency (flagged by
// `import/no-cycle`) that also crashes under webpack 5 with a temporal-dead-zone
// error ("Cannot access '__WEBPACK_DEFAULT_EXPORT__' before initialization").
// The Documents base route is rendered by `./index` itself via its own view
// switching, so no self `component` reference is needed here.
import DocumentForm from "./Form";

const path = '/dashboard/documents';

const routes = [
  // {
  //   name: 'Main Area',
  //   path: `${path}/mainArea`,
  //   icon: 'home',
  //   component: Documents,
  // },
  {
    name: "Documents",
    path: `${path}`,
    icon: "users",
    // component is rendered by ./index itself (see note above); no self-ref here.
    // exact: true
  },
  {
    name: "Documents Form",
    path: [
      `${path}/create`,
      `${path}/:id`,
      `${path}/:id/update`,
    ],
    icon: "users",
    component: DocumentForm,
  },
];

export default routes;

export const redirects = [
  {
    from: `${path}/*`,
    to: `${path}`,
  },
];
